/**
 * 질의 내역 필터링 및 정렬 관련 순수 유틸리티 함수.
 */

export const sortByDate = (arr, order = 'desc') => {
    return [...arr].sort((a, b) => {
        let timeA = new Date(a.created_at).getTime();
        let timeB = new Date(b.created_at).getTime();
        if (isNaN(timeA)) timeA = 0;
        if (isNaN(timeB)) timeB = 0;
        if (timeA === timeB) {
            const idA = String(a.id || '');
            const idB = String(b.id || '');
            return order === 'desc' ? idB.localeCompare(idA) : idA.localeCompare(idB);
        }
        return order === 'desc' ? timeB - timeA : timeA - timeB;
    });
};

export const filterInquiryData = (data, filters, viewMode, currentUser) => {
    const {
        personalSearch,
        companyNameSearch,
        companyContentSearch,
        adminCompanySearch,
        statusFilter,
        startDate,
        endDate
    } = filters;

    return data.filter(item => {
        // 권한 필터 (낙관적 UI 반영된 데이터 포함 처리)
        if (viewMode === 'personal' && item.user_id && currentUser.id &&
            String(item.user_id) !== String(currentUser.id)) return false;

        // 상태 필터
        if (statusFilter !== 'all' && item.answer_status !== statusFilter) return false;

        // 기간 필터
        const createdAt = item.created_at || '';
        const itemDate = new Date(createdAt.split(' ')[0] || Date.now());
        if (startDate && itemDate < new Date(startDate)) return false;
        if (endDate && itemDate > new Date(endDate)) return false;

        // 검색어 필터
        const questionStr = item.question || '';
        const userNameStr = item.user_name || '';
        const companyCodeStr = item.company_code || '';
        const companyNameStr = item.company_name || '';

        if (viewMode === 'personal') {
            return questionStr.toLowerCase().includes(personalSearch.toLowerCase());
        }
        
        if (viewMode === 'admin') {
            const companySearchStr = adminCompanySearch.toLowerCase();
            const companyMatch = !companySearchStr ||
                companyNameStr.toLowerCase().includes(companySearchStr) ||
                companyCodeStr.toLowerCase().includes(companySearchStr);
            return companyMatch && questionStr.toLowerCase().includes(companyContentSearch.toLowerCase());
        }
        
        // company 모드: 이름 검색 + 대화 내용 검색
        return (
            userNameStr.toLowerCase().includes(companyNameSearch.toLowerCase()) &&
            questionStr.toLowerCase().includes(companyContentSearch.toLowerCase())
        );
    });
};

export const formatNow = () => {
    const d = new Date();
    return d.getFullYear() + '-' +
        String(d.getMonth() + 1).padStart(2, '0') + '-' +
        String(d.getDate()).padStart(2, '0') + ' ' +
        String(d.getHours()).padStart(2, '0') + ':' +
        String(d.getMinutes()).padStart(2, '0') + ':' +
        String(d.getSeconds()).padStart(2, '0');
};

/**
 * 두 날짜가 같은 날인지 확인 (연-월-일 기준)
 */
export const isSameDay = (date1, date2) => {
    if (!date1 || !date2) return false;
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    return (
        d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate()
    );
};

/**
 * 대화 구분선에 표시할 날짜 레이블 생성 ("오늘", "어제" 또는 "2024년 4월 7일 (화)")
 */
export const getDateLabel = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const now = new Date();

    // 오늘
    if (isSameDay(date, now)) return '오늘';

    // 어제
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    if (isSameDay(date, yesterday)) return '어제';

    // 그 외: "2024년 4월 7일 (일)" 형태로 포맷팅
    const options = { year: 'numeric', month: 'long', day: 'numeric', weekday: 'short' };
    return date.toLocaleDateString('ko-KR', options);
};
